/**
 * Pure helper shared between AuditStageIndicator and StatusBadge (pirx-qydoj.8).
 * Split out of AuditStageIndicator.tsx so that file stays component-only
 * (react-refresh/only-export-components) while StatusBadge can decide,
 * without duplicating the resolution logic, whether a PROCESSING audit has
 * stage info worth a tooltip.
 */
import type { AuditProcessingStage } from "@vardic/shared/types";

/**
 * Resolve the translated label for a processing stage from the closed
 * i18n map. `t()` returns the key itself when the key is missing; we guard
 * against that by checking whether the returned value differs from the
 * lookup path — if so (key truly missing or currentStep absent), there's
 * nothing to show.
 */
export function resolveStageLabel(
  currentStep: AuditProcessingStage | null | undefined,
  t: (key: string) => string,
): string | null {
  const labelKey = currentStep ? `stage.${currentStep}` : null;
  const rawLabel = labelKey ? t(labelKey) : null;
  return rawLabel && rawLabel !== labelKey ? rawLabel : null;
}
